@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  min-height: 100%;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.description {
  color: var(--dark-80);
}

.descriptionContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.keyphraseContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
}

.inputContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.inputLabel {
  @include xs-sohne-book;
  color: var(--dark-60);
}

.errorContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 16px;
}

.resultCategories {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.resultCategory {
  @include thinScrollbar;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: var(--light-40);
  padding: 10px;
  gap: 20px;
  box-shadow: 1px 1px 0px 0px var(--light-90) inset, 0px 2px 12px 0px var(--dark-4);
  @include blur(35px);

  [data-autopilot-system-redesign='on'] & {
    @include blur(0);
    box-shadow: none;
    border: 1px solid var(--dark-4);
  }
}

.resultCategoryHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  gap: 10px;
}

.resultCategoryTitle {
  color: var(--dark-80);
}

.resultCategoryScore {
  color: var(--neutral-30);
  @include sm-medium;
}

.chevron {
  @include transition(0.1s);
  display: flex;
  align-items: center;

  &.expanded {
    transform: rotate(90deg);
  }
}

.resultsList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.resultItem {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
  align-self: stretch;

  @include md-regular;
}

.resultHeader {
  display: flex;
  align-items: center;
  gap: 6px;
}

.results {
  display: flex;
  align-items: center;
  gap: 10px;
}

.resultIcon {
  display: flex;
  width: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
}

.resultContent {
  color: var(--dark-60);
  @include xs-sohne-book;
}

.good {
  color: var(--green-50);
}

.warning {
  color: var(--orange-70);
}

.problem {
  color: var(--red-70);
}

.icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.seoScore {
  margin: 0px 0px 10px 0px;
}
